// src/pages/Appli/AppliAdmin/ListingClients/charts/AssosByDisciplineBar.jsx

import React, { useMemo } from "react";

import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import {
  splitDisciplines,
} from "../utils/association.utils";

function shortenLabel(value) {
  const label = String(value || "");

  return label.length > 20
    ? `${label.slice(0, 19)}…`
    : label;
}

export function AssosByDisciplineBar({
  data = [],
}) {
  const series = useMemo(() => {
    const counts = new Map();

    data.forEach((association) => {
      const disciplines = splitDisciplines(
        association.discipline_asso,
      );

      if (!disciplines.length) {
        counts.set(
          "Non renseignée",
          (counts.get("Non renseignée") || 0) + 1,
        );

        return;
      }

      disciplines.forEach((discipline) => {
        counts.set(
          discipline,
          (counts.get(discipline) || 0) + 1,
        );
      });
    });

    const sorted = [...counts.entries()]
      .map(([name, count]) => ({
        name,
        count,
      }))
      .sort(
        (first, second) =>
          second.count - first.count,
      );

    if (sorted.length <= 10) {
      return sorted;
    }

    const visible = sorted.slice(0, 9);

    const otherCount = sorted
      .slice(9)
      .reduce(
        (sum, item) => sum + item.count,
        0,
      );

    return [
      ...visible,
      {
        name: "Autres disciplines",
        count: otherCount,
      },
    ];
  }, [data]);

  if (!series.length) {
    return (
      <div className="flex h-72 items-center justify-center text-sm text-slate-400">
        Aucune donnée disponible
      </div>
    );
  }

  return (
    <div className="h-72">
      <ResponsiveContainer
        width="100%"
        height="100%"
      >
        <BarChart
          data={series}
          layout="vertical"
          margin={{
            top: 5,
            right: 20,
            bottom: 5,
            left: 15,
          }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            stroke="#cbd5e1"
            opacity={0.45}
          />

          <XAxis
            type="number"
            allowDecimals={false}
            tick={{ fill: "#94a3b8", fontSize: 11 }}
          />

          <YAxis
            type="category"
            dataKey="name"
            width={135}
            tickFormatter={shortenLabel}
            tick={{ fill: "#64748b", fontSize: 11 }}
          />

          <Tooltip
            cursor={{ fill: "#06b6d410" }}
            formatter={(value) => [
              `${value} dossier${
                value > 1 ? "s" : ""
              }`,
              "Total",
            ]}
          />

          <Bar
            dataKey="count"
            fill="#06b6d4"
            radius={[0, 6, 6, 0]}
            maxBarSize={24}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AssosByDisciplineBar;